import { handleActions } from 'redux-actions';

import { SHOW_TOAST, HIDE_TOAST } from '../../types';

const initialState = {
  type: null,
  message: null,
  show: false,
  delay: null
};

const toastReducer = {
  [SHOW_TOAST]: (state = initialState, { payload }) => ({
    ...state,
    message: payload.message,
    type: payload.type,
    show: true,
    delay: payload.delay
  }),
  [HIDE_TOAST]: () => ({
    type: null,
    message: null,
    show: false,
    delay: null
  })
};

const toast = handleActions(
  {
    ...toastReducer
  },
  initialState
);

export default toast;
